// Copyright (c) 2025 Just Feasible Solutions LLC. All rights reserved.
// This file is part of the Just Feasible Solutions application.
// Unauthorized copying, distribution, or modification of this file is prohibited.
// For license information, contact the author.

import React from 'react';

const SocialMediaDisclaimer = () => (
  <div style={{ maxWidth: 900, margin: '0 auto', padding: '2rem' }}>
    <h1>Social Media Disclaimer</h1>
    <p>
      Content shared by Just Feasible Solutions LLC ("Just Feasible Solutions") on social media platforms is for informational purposes only and does not constitute legal, financial, or professional advice. While we strive to provide accurate and timely information, we make no guarantees regarding the completeness or accuracy of any content posted on our social media channels.
    </p>
    <ul>
      <li>Engagements (likes, shares, comments) do not imply endorsement of any individual, organization, or product.</li>
      <li>Links to third-party websites or resources are provided for convenience and do not constitute an endorsement or approval by Just Feasible Solutions.</li>
      <li>We are not responsible for the content, privacy, or security practices of external sites or social media platforms.</li>
      <li>Opinions expressed by followers or third parties do not necessarily reflect the views of Just Feasible Solutions LLC.</li>
      <li>We reserve the right to moderate, remove, or restrict content and comments on our social media pages at our discretion.</li>
    </ul>
    <p>
      For questions or concerns about our social media content or practices, please contact us at <a href="mailto:support@justfeasible.com">support@justfeasible.com</a>.
    </p>
    <p style={{ marginTop: 32, color: '#888', fontSize: '0.97rem' }}>
      &copy; 2025 Just Feasible Solutions LLC. All rights reserved.
    </p>
  </div>
);

export default SocialMediaDisclaimer;
